import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErzeugungsanlageService } from '../../../service/erzeugungsanlage/erzeugungsanlage.service';
import { inject, Injectable } from '@angular/core';
import {
    FunkrundsteuerEmpfaengerInformationen,
} from '../../../domain/model/funkrundsteuer-empfeanger-informationen.model';
import { TeilgebietSelectionService } from '../../../service/common/teilgebiet/teilgebiet-selection.service';

@Injectable({
    providedIn: 'root',
})
export class SteuerbareResourceIdValidator {

    private erzeugungsanlageService = inject(ErzeugungsanlageService);
    private teilgebieteService = inject(TeilgebietSelectionService);

    validate(
        netzzuordnungId?: string,
        funkrundsteuerEmpfaengerInformationen?: FunkrundsteuerEmpfaengerInformationen,
        steuergruppeId?: string,
        dokumentenId?: string,
    ): AsyncValidatorFn {
        return (control: AbstractControl): Observable<ValidationErrors | null> => {
            if (!!netzzuordnungId && funkrundsteuerEmpfaengerInformationen && control.value?.length == 11) {
                return this.erzeugungsanlageService.getSteuerbareResourceIdConflicts(
                    control.value,
                    netzzuordnungId,
                    funkrundsteuerEmpfaengerInformationen,
                    steuergruppeId,
                    this.teilgebieteService.getSelectedStadtwerkeId(),
                    dokumentenId,
                ).pipe(
                    map(conflicts => (!conflicts.length ? null : { steuerbareResourceIdConflict: true })),
                    catchError(() => {
                        console.error('Error while checking if steuerbareResourceId has conflicts');
                        return of({ steuerbareResourceIdConflict: true });
                    }),
                );
            }
            return of(null);
        };
    }
}
